import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs/internal/BehaviorSubject";
import {PageMetaI} from "../../builder-v2.interface";

@Injectable({
  providedIn: 'root'
})
export class SinglePageService {
  page: BehaviorSubject<PageMetaI> = new BehaviorSubject<PageMetaI>(null);
  pageForm = null;
  siteData = null;

  constructor() {
  }
}
